import IApplicationState from 'app/types/state';
import { IGroupsState, IGroupsSelector } from 'app/ducks/groups/types';
import _ from 'lodash';
import { getCompetitionById } from 'app/ducks/competitions/selectors';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.groups.groupsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return {};
}

export function getGroupsFilteredByTagInSelectFormat(
  state: IApplicationState,
  tagId,
): any {
  const { groupsById }: IGroupsState = state.groups;
  const groups = _.filter(groupsById, { tags: [tagId] });
  const sortedGroups = _.sortBy(groups, (o) => o.name);
  const mappedGroups = _.map(sortedGroups, (n) => mapSelect(state, n.id));
  return mappedGroups;
}

export function getGroupsFilteredByTagAndCompetitionInSelectFormat(
  state: IApplicationState,
  tagId,
  competitionId,
): any {
  const { groupsById }: IGroupsState = state.groups;
  let groups;
  if (_.isEmpty(tagId)) {
    groups = _.filter(groupsById, {
      competition: { id: competitionId },
    });
  } else {
    groups = _.filter(groupsById, {
      competition: { id: competitionId },
      sectionName: tagId,
    });
  }

  const sortedGroups = _.sortBy(groups, (o) => o.name);
  const mappedGroups = _.map(sortedGroups, (n) => mapSelect(state, n.id));
  return mappedGroups;
}

export function getGroupsByIdInSelectFormat(state): any {
  const { groupsById } = state.groups;
  const sortedGroups = _.sortBy(groupsById, (o) => o.name);
  const mappedTeams = _.map(sortedGroups, (n) => mapSelect(state, n.id));
  return mappedTeams;
}

export function getGroup(state, group): any {
  if (group != null) {
    const findCompetition = !_.isEmpty(group.competition)
      ? getCompetitionById(state, group.competition.id)
      : {};
    return {
      ...group,
      competition: {
        ...findCompetition,
      },
    };
  }
  return {};
}

export function getGroupById(state, id): any {
  if (state.groups.groupsById !== undefined && id != null) {
    return getGroup(state, state.groups.groupsById[id]);
  }
  return {};
}

export function getCurrentGroup(state): any {
  if (
    state.groups?.groupsById !== undefined
    && state.groups?.currentGroupId !== undefined
    && !_.isEmpty(state.groups.groupsById[state.groups.currentGroupId])
  ) {
    const findGroup = state.groups.groupsById[state.groups.currentGroupId];
    return findGroup;
  }
  return {};
}

export function getGroups(state): IGroupsSelector {
  return {
    ...state.groups,
    currentGroup: getCurrentGroup(state),
    groupsByIdInSelectFormat: getGroupsByIdInSelectFormat(state),
    groupsFilteredByTagInSelectFormat: (tagId): any => getGroupsFilteredByTagInSelectFormat(state, tagId),
    groupsFilteredByTagAndCompetitionInSelectFormat: (
      tagId,
      competitionId,
    ): any => getGroupsFilteredByTagAndCompetitionInSelectFormat(
      state,
      tagId,
      competitionId,
    ),
  };
}
